<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.attentions')"
      >Volver a Atenciones</back-profile
    >

    <attentions-by-type-header
      :bordered-header="true"
      :total-pending="this.totalByType('PENDING')"
      :total-failed="this.totalByType('FAILED')"
      :total-completed="this.totalByType('COMPLETED')"
      style="padding-bottom: 25px; margin: 10px 0;"
    >
      <template slot="header">
        <div v-if="this.attentionsByType[0]">{{ attentionTitle(this.attentionsByType[0]) }}</div>
      </template>
    </attentions-by-type-header>

    <attentions-by-type-body
      :attentions="this.attentionByState()"
      @finish-attention="finishAttention"
    ></attentions-by-type-body>
  </div>
</template>

<script>
import moment from "moment"
import ATTENTIONS_BY_TYPE from "./graphql/AttentionsByType.gql"
import Block from "@/components/_base/Block.vue"
import AttentionsByTypeHeader from "@/components/_base/AttentionsByTypeHeader.vue"
import AttentionsByTypeBody from "@/components/_base/AttentionsByTypeBody.vue"
import BackProfile from "@/components/_base/BackProfile.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileAttentionsByType",

  components: {
    Block,
    BackProfile,
    AttentionsByTypeHeader,
    AttentionsByTypeBody
  },

  props: {
    studentId: {
      type: String
    },
    attentionActionId: {
      type: String
    }
  },

  data() {
    return {
      attentionsByType: []
    }
  },

  apollo: {
    attentionsByType: {
      query: ATTENTIONS_BY_TYPE,
      variables() {
        return {
          tareaId: this.attentionActionId,
          studentId: this.studentId
        }
      }
    }
  },

  methods: {
    attentionByState() {
      let orderedAttentions = []

      for (let i = 0; i < this.attentionsByType.length; i++) {
        if (this.attentionsByType[i].status === "PENDING") {
          orderedAttentions.unshift(this.attentionsByType[i])
        } else {
          orderedAttentions.push(this.attentionsByType[i])
        }
      }

      return orderedAttentions
    },
    finishAttention(attentionId) {
      console.log("Finish attention Type")
      this.navigateTo({
        state: "app.profile.finish_attention",
        params: {
          attentionId
        }
      })
    },
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    attentionTitle(item) {
      if (item.action.plan && item.action.plan.category) {
        let title = item.action.plan.category.name
        if (!item.action.plan.hidden && item.action.plan) title += " - " + item.action.plan.name
        if (!item.action.hidden && item.action) title += " - " + item.action.name
        return title
      } else {
        return item.action.name
      }
    },
    totalByType(type) {
      let total = 0
      this.attentionsByType.map(a => {
        if (a.status === type) {
          total += 1
        }
      })
      return total
    }
  },

  filters: {
    humanizeDate(date) {
      if (date === null) {
        return "-"
      } else {
        const m = moment(date)
        return m.fromNow()
      }
    }
  }
}
</script>

<style scoped>
.meta-list {
  margin-bottom: 30px;
}

.meta-item {
  margin-bottom: 10px;
}

.description {
  margin-bottom: 20px;
}

.emotion {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  transform: rotate(90deg);
  font-size: 18px;
  line-height: 18px;
  width: 30px;
  height: 30px;
  pointer-events: none;
}

li {
  list-style-type: none;
}
</style>
